import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LEGAL_EMAIL } from "@/legal/content";

// Discreet legal links (Landing footer). No redesign: small muted row.
export function LegalFooter() {
  const { t } = useTranslation();
  const cls = "text-muted-foreground underline-offset-4 transition-colors hover:text-[#7FD4FF] hover:underline";
  return (
    <footer data-testid="legal-footer" className="relative mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-6 gap-y-2 px-6 pb-8 text-[11px] uppercase tracking-[0.18em] sm:justify-end sm:px-10">
      <Link to="/tutorial" data-testid="footer-tutorial" className={cls}>{t("legal.tutorial")}</Link>
      <Link to="/privacy" data-testid="footer-privacy" className={cls}>{t("legal.privacy")}</Link>
      <Link to="/terms" data-testid="footer-terms" className={cls}>{t("legal.terms")}</Link>
      <a href={`mailto:${LEGAL_EMAIL}`} data-testid="footer-contact" className={cls}>{t("legal.contact")}</a>
    </footer>
  );
}
